import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Drawer } from '../../components/ui/Drawer';
import { Tabs } from '../../components/ui/Tabs';
import { AlertCircleIcon, CheckCircleIcon, ClockIcon, FileTextIcon } from 'lucide-react';
const tasks = [{
  id: '1',
  title: 'Acknowledge PO-2026-8892',
  desc: 'Please review and acknowledge the new purchase order for Fresh Produce.',
  due: 'Today',
  priority: 'High',
  type: 'Order',
  status: 'Pending'
}, {
  id: '2',
  title: 'Upload renewed Halal Certification',
  desc: 'Your current certification expires in 5 days. Please upload the renewal.',
  due: 'Tomorrow',
  priority: 'High',
  type: 'Compliance',
  status: 'Pending'
}, {
  id: '3',
  title: 'Review proposed contract amendment',
  desc: 'Legal has proposed changes to the liability clause.',
  due: 'Mar 18',
  priority: 'Medium',
  type: 'Contract',
  status: 'Pending'
}, {
  id: '4',
  title: 'Complete Annual ESG Questionnaire',
  desc: 'Required for all tier 1 suppliers.',
  due: 'Mar 25',
  priority: 'Low',
  type: 'Onboarding',
  status: 'Pending'
}];
export const TaskInbox: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedTask, setSelectedTask] = useState<any>(null);
  return <div className="max-w-7xl mx-auto h-[calc(100vh-8rem)] flex flex-col" data-id="element-1882">
      <PageHeader title="Task Inbox" description="Manage your pending actions and requests." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Task Inbox'
    }]} data-id="element-1883" />

      <Card className="flex-1 flex flex-col overflow-hidden noPadding" data-id="element-1884">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-1885">
          <Tabs tabs={[{
          id: 'all',
          label: 'All Tasks',
          count: 4
        }, {
          id: 'urgent',
          label: 'Urgent',
          count: 2
        }, {
          id: 'completed',
          label: 'Completed'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1886" />
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-3" data-id="element-1887">
          {tasks.map(task => <div key={task.id} className="flex items-start p-4 border border-border-light rounded-fluent-lg hover:border-fpg-navy hover:shadow-elevation-1 cursor-pointer transition-all bg-surface-primary" onClick={() => setSelectedTask(task)} data-id="element-1888">
              <div className="mr-4 mt-1" data-id="element-1889">
                {task.priority === 'High' ? <AlertCircleIcon className="w-5 h-5 text-status-error" data-id="element-1890" /> : <ClockIcon className="w-5 h-5 text-status-warning" data-id="element-1891" />}
              </div>
              <div className="flex-1" data-id="element-1892">
                <div className="flex justify-between items-start mb-1" data-id="element-1893">
                  <h3 className="text-base font-semibold text-text-primary" data-id="element-1894">
                    {task.title}
                  </h3>
                  <Badge variant={task.priority === 'High' ? 'error' : 'warning'} data-id="element-1895">
                    {task.due}
                  </Badge>
                </div>
                <p className="text-sm text-text-secondary mb-3" data-id="element-1896">{task.desc}</p>
                <div className="flex items-center gap-2" data-id="element-1897">
                  <Badge variant="neutral" size="sm" data-id="element-1898">
                    {task.type}
                  </Badge>
                </div>
              </div>
            </div>)}
        </div>
      </Card>

      <Drawer isOpen={!!selectedTask} onClose={() => setSelectedTask(null)} title="Task Details" size="md" footer={<>
            <Button variant="ghost" onClick={() => setSelectedTask(null)} data-id="element-1900">
              Cancel
            </Button>
            <Button variant="secondary" data-id="element-1901">Delegate</Button>
            <Button variant="primary" leftIcon={<CheckCircleIcon className="w-4 h-4" data-id="element-1903" />} data-id="element-1902">
              Complete Now
            </Button>
          </>} data-id="element-1899">
        {selectedTask && <div className="space-y-6" data-id="element-1904">
            <div data-id="element-1905">
              <div className="flex items-center gap-2 mb-2" data-id="element-1906">
                <Badge variant="neutral" data-id="element-1907">{selectedTask.type}</Badge>
                <Badge variant={selectedTask.priority === 'High' ? 'error' : 'warning'} data-id="element-1908">
                  Due: {selectedTask.due}
                </Badge>
              </div>
              <h2 className="text-xl font-bold text-text-primary mb-2" data-id="element-1909">
                {selectedTask.title}
              </h2>
              <p className="text-text-secondary" data-id="element-1910">{selectedTask.desc}</p>
            </div>

            <div className="p-4 bg-surface-secondary rounded-fluent-lg border border-border-light" data-id="element-1911">
              <h3 className="text-sm font-semibold text-text-primary mb-2 flex items-center gap-2" data-id="element-1912">
                <FileTextIcon className="w-4 h-4" data-id="element-1913" /> Related Object
              </h3>
              <p className="text-sm text-fpg-navy hover:underline cursor-pointer" data-id="element-1914">
                View {selectedTask.type} Record
              </p>
            </div>

            <div data-id="element-1915">
              <h3 className="text-sm font-semibold text-text-primary mb-2" data-id="element-1916">
                Instructions
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-1917">
                Please click "Complete Now" to be taken to the relevant page to
                resolve this task. If you need assistance, you can delegate this
                to another team member or contact support.
              </p>
            </div>
          </div>}
      </Drawer>
    </div>;
};